export const SET_LOADING_DATA = '@auditUser/SET_LOADING_DATA';
export const SET_LOADING_SELECTS = '@auditUser/SET_LOADING_SELECTS';

export const GET_LIST_ALL_AUDIT_USER_REQUEST = '@auditUser/GET_LIST_ALL_AUDIT_USER_REQUEST';
export const GET_LIST_ALL_AUDIT_USER_SUCCESS = '@auditUser/GET_LIST_ALL_AUDIT_USER_SUCCESS';

export const SET_PAGE = '@auditUser/SET_PAGE';
export const SET_ROWS_COUNT = '@auditUser/SET_ROWS_COUNT';
export const SET_ROWS_PER_PAGE = '@auditUser/SET_ROWS_PER_PAGE';
export const SET_ORDER = '@auditUser/SET_ORDER';
export const SET_ORDERBY = '@auditUser/SET_ORDERBY';
